import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FindYourNextHorizon from "./sections/FindYourNextHorizon";
import TrendingEscapes from "./sections/TrendingEscapes";
import TheWanderlustPhilosophy from "./sections/TheWanderlustPhilosophy";
import GlobalFootprint from "./sections/GlobalFootprint";
import VoicesOfTheRoad from "./sections/VoicesOfTheRoad";
import ReadyForTakeoff from "./sections/ReadyForTakeoff";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FindYourNextHorizon />
      <TrendingEscapes />
      <TheWanderlustPhilosophy />
      <GlobalFootprint />
      <VoicesOfTheRoad />
      <ReadyForTakeoff />
      <Footer />
    </div>;
}